
import { copyToClipboard } from 'quasar'
import { Component, Prop, Vue } from 'vue-property-decorator'

import PixAutomaticoModel from '../models/PixAutomatico'
import SubscriptionModel from '../models/Subscription'

import { formatAmount } from '../utils/format'
import EButton from './Button.vue'
import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EButton,
    EPaymentInfo,
  },
})
export default class PixAutomatico extends Vue {
  @Prop({ required: true }) readonly pix!: PixAutomaticoModel
  @Prop({ required: true }) readonly subscription!: SubscriptionModel
  readonly formattedAmount = formatAmount(this.subscription.amount)

  copied = false;

  private async copyPixCode() {
    const pixCode = this.pix.code

    try {
      await copyToClipboard(pixCode)

      this.copied = true
      this.$emit('copy')
      setTimeout(() => { this.copied = false }, 1100)
    } catch (err) {
      console.error(err)
    }
  }
}
